/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CharCriteriaOutput
 */
export interface CharCriteriaOutput {
    /**
     * 
     * @type {boolean}
     * @memberof CharCriteriaOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CharCriteriaOutput
     */
    value?: string;
}

export function CharCriteriaOutputFromJSON(json: any): CharCriteriaOutput {
    return CharCriteriaOutputFromJSONTyped(json, false);
}

export function CharCriteriaOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CharCriteriaOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function CharCriteriaOutputToJSON(value?: CharCriteriaOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': value.value,
    };
}


